const styles = () => {
  return {
    root: {
      width: '100%'
    }
  };
};

export default styles;
